import { Component,Input,OnInit } from '@angular/core';
import { BusinessAdsService } from '@app/services/BusinessAds/businessAds.service';
import { environment } from '../../../environments/environment.prod';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.css'],
})
export class ProductsComponent implements OnInit {
  businessAds:any;
  serverImgUrl:any;
  
  hideshow: boolean = false;
  toggle() {
    this.hideshow = !this.hideshow;
  }

  constructor(
    private adsService: BusinessAdsService) { }

  ngOnInit(){
    this.serverImgUrl = environment.IMG_URL;
    this.getBusinessAds();
  }

  // Get all business
  getBusinessAds(): void {
    this.adsService.getTop8BusinessAds().subscribe({
      next: (response:any) => {
        this.businessAds = response.data; 
        }
      }
    );
  }

}